import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  class: "w-100",
  style: {"text-align":"center"}
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "form-group col-12 mt-3 control-container" }
const _hoisted_5 = { class: "form-label" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group col-12 mt-3 control-container" }
const _hoisted_8 = { class: "form-label" }
const _hoisted_9 = { class: "row d-none" }
const _hoisted_10 = { class: "inline-block dv-options" }
const _hoisted_11 = {
  class: "pointer",
  for: "keepSession"
}
const _hoisted_12 = { class: "row d-none" }
const _hoisted_13 = { class: "dv-options-2 pointer" }
const _hoisted_14 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "loginButton" }
const _hoisted_17 = {
  key: 2,
  class: "row col-12 text-center mt-5",
  style: {"color":"var(--color-primary)"}
}

import InputText from 'primevue/inputtext';
import ErrorMsg from '@/views/shared/ErrorMsg.vue';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { toTypedSchema } from '@vee-validate/yup';
import { traduceTexto } from '@/core/services/base/GlobalFunctios';
import { PropType, onMounted } from 'vue';

import { eStatusCode } from '@/core/model/GloblasEnum';

interface IServerResponse {
  tipo: number,
  msg: string  
}

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginFormComponent',
  props: { 
 type:Number,
 serverResponse: Object as PropType<IServerResponse>,
 loading:Boolean
},
  emits: ['onLogin'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;
const { errors,handleSubmit, defineField } = useForm(
{
    validationSchema: toTypedSchema(
    yup.object(
    {
        userId: yup.string().required(traduceTexto('globals.requerido')),
        clave: yup.string().required(traduceTexto('globals.requerido')),
        keepSesion:yup.boolean()
    })),
});
const [userId] = defineField('userId');
const [clave] = defineField('clave');
const [keepSesion] = defineField('keepSesion');
const onLogin = handleSubmit((values) => 
{          
    emits('onLogin',values); 
});
onMounted(()=>
{
   const inputField: HTMLElement|null = document.getElementById('txtUser');
   inputField && inputField.focus();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container-fluid dv-login", {'dv-login-admin':props.type === 1,
                  'dv-login-customer':props.type === 2}])
  }, [
    _createElementVNode("form", {
      id: "frmLogin",
      autocomplete: "off",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onLogin) && _unref(onLogin)(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Login.Title')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('Login.Usuario')), 1),
          _createVNode(_unref(InputText), {
            id: "txtUser",
            class: _normalizeClass({'ng-invalid ng-dirty':_unref(errors).userId}),
            modelValue: _unref(userId),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(userId) ? (userId).value = $event : null))
          }, null, 8, ["class", "modelValue"]),
          _createVNode(ErrorMsg, {
            error: _unref(errors).userId
          }, null, 8, ["error"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Login.Contrasena')), 1),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            class: _normalizeClass(["p-inputtext", {'ng-invalid ng-dirty':_unref(errors).clave}]),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(clave) ? (clave).value = $event : null))
          }, null, 2), [
            [_vModelText, _unref(clave)]
          ]),
          _createVNode(ErrorMsg, {
            error: _unref(errors).clave
          }, null, 8, ["error"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(Checkbox), {
            modelValue: _unref(keepSesion),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(keepSesion) ? (keepSesion).value = $event : null)),
            binary: true,
            inputId: "keepSession"
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", _hoisted_11, "  " + _toDisplayString(_ctx.$t('Login.KeepSesion')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('Login.ForgotPass')), 1)
      ]),
      (__props.serverResponse && __props.serverResponse.msg)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["row col-12 mt-3 mb-3 dv-notificacion", {'dv-notificacion-ok':__props.serverResponse.tipo === _unref(eStatusCode).Ok ,
                         'dv-notificacion-error':__props.serverResponse.tipo !== _unref(eStatusCode).Ok}])
          }, _toDisplayString(__props.serverResponse.msg), 3))
        : _createCommentVNode("", true),
      (!props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(Button), { type: "submit" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Login.Entrar')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _cache[4] || (_cache[4] = _createElementVNode("i", {
              class: "pi pi-spin pi-spinner",
              style: {"font-size":"110%","margin-right":"7px"}
            }, null, -1)),
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('globals.espere')), 1)
          ]))
    ], 32)
  ], 2))
}
}

})